var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getClient } from '../bridge/src/client';
export var frontEndApi = getClient({
    ajaxurl: '/wp/wp-admin/admin-ajax.php',
    ajaxAction: 'FrontEnd',
});
Object.freeze(frontEndApi);
var capturedScrollY = 0;
export function scrollToCapturedPosition() {
    window.scrollTo({ left: 0, top: capturedScrollY, behavior: 'auto' });
}
export function freezeWindowScroll() {
    if (!isSafari()) {
        capturedScrollY = window.pageYOffset;
        window.addEventListener('scroll', scrollToCapturedPosition);
    }
}
export function releaseWindowScroll() {
    if (!isSafari()) {
        capturedScrollY = 0;
        window.removeEventListener('scroll', scrollToCapturedPosition);
    }
}
export var EMAIL_RE = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export var USER_BEHAVIOR = {
    hadInteraction: false,
};
function detectUserInteraction(event) {
    if (event.isTrusted) {
        USER_BEHAVIOR.hadInteraction = true;
        window.document.documentElement.removeEventListener(event.type, detectUserInteraction);
    }
}
;
['click', 'touchmove', 'focus', 'keydown'].forEach(function (interaction) {
    window.document.documentElement.addEventListener(interaction, detectUserInteraction);
});
export function getVideoParser() {
    return {
        parse: function (url) {
            if (url === void 0) { url = ''; }
            url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/);
            var type = null;
            if (RegExp.$3.indexOf('youtu') > -1) {
                type = 'youtube';
            }
            else if (RegExp.$3.indexOf('vimeo') > -1) {
                type = 'vimeo';
            }
            return {
                type: type,
                id: RegExp.$6,
            };
        },
        makeIFrame: function (url, attributes) {
            if (attributes === void 0) { attributes = {}; }
            var video = this.parse(url), iframe = document.createElement('iframe'), attrs = Object.assign({
                frameborder: '0',
            }, attributes);
            for (var attr in attrs) {
                if (attrs.hasOwnProperty(attr)) {
                    iframe.setAttribute(attr, attrs[attr]);
                }
            }
            if (video.type === 'youtube') {
                iframe.setAttribute('src', '//www.youtube.com/embed/' + video.id);
            }
            else if (video.type === 'vimeo') {
                iframe.setAttribute('src', '//player.vimeo.com/video/' + video.id);
            }
            return iframe;
        },
        getThumbnail: function (url) {
            return __awaiter(this, void 0, void 0, function () {
                var video, data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            video = this.parse(url);
                            if (!(video.type === 'youtube')) return [3 /*break*/, 1];
                            return [2 /*return*/, "//img.youtube.com/vi/".concat(video.id, "/maxresdefault.jpg")];
                        case 1:
                            if (!(video.type === 'vimeo')) return [3 /*break*/, 3];
                            return [4 /*yield*/, jQuery.get("//vimeo.com/api/v2/video/".concat(video.id, ".json"))];
                        case 2:
                            data = _a.sent();
                            if (data) {
                                return [2 /*return*/, data[0].thumbnail_large];
                            }
                            _a.label = 3;
                        case 3: return [2 /*return*/, null];
                    }
                });
            });
        },
    };
}
var loop = getAnimationLoop();
Object.freeze(loop);
export var animationLoop = loop;
export function getAnimationLoop() {
    var cbs = [];
    var af = null, running = false;
    function subscribe(cb) {
        cbs.push(cb);
    }
    function unsubscribe(cb) {
        var idx = cbs.findIndex(function (c) { return c === cb; });
        if (idx) {
            cbs.splice(idx, 1);
        }
    }
    function start() {
        cbs.forEach(function (cb) { return cb(); });
        af = window.requestAnimationFrame(start);
        running = true;
    }
    function stop() {
        window.cancelAnimationFrame(af);
        running = false;
    }
    return { subscribe: subscribe, unsubscribe: unsubscribe, stop: stop, start: start, isRunning: function () { return running; } };
}
export function isSafari() {
    return window.IS_SAFARI || false;
}
